import { Directive, ElementRef, Renderer2 } from '@angular/core';
@Directive({
  selector: '[tooltipCleaner]'
})
export class TooltipCleanerDirective {
  private nativeElement : Node;
  constructor( private renderer : Renderer2, private element : ElementRef ) {
    this.nativeElement = element.nativeElement;
  }

  ngAfterContentInit() {

    let tooltip =this.renderer.selectRootElement('.tooltipped');
    console.log('tooltip.html: >>>' + tooltip.outerHTML);
    console.log('element.html: >>>' + this.element.nativeElement.outerHTML);
    // while(tooltip){
      this.renderer.removeAttribute(this.element, 'materialize');
      //  tooltip = this.renderer.selectRootElement('.tooltipped'); 
    // }

    tooltip = this.renderer.nextSibling(tooltip);
    if (tooltip){
      console.log('tooltip2.html: >>>' + tooltip.outerHTML);
      // console.log('element2.html: >>>' + this.element.nativeElement.outerHTML);
      this.renderer.removeAttribute(tooltip, 'materialize');
    }

    
    // this.renderer.removeClass(tooltips, 'material-tooltip');
    // this.renderer.removeAttribute(tooltips, 'materialize');

    // this.renderer.removeAttribute(this.nativeElement, 'materialize');
    
  }
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/tooltip-cleaner.directive.ts